"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.seriesNamesFilterer = exports.identityTransformer = exports.DataDescriptionYearName = void 0;
var lodash_1 = __importDefault(require("lodash"));
exports.DataDescriptionYearName = 'YEAR';
exports.identityTransformer = function (d) { return d; };
var seriesHeaderSortValue = function (header) {
    var sortValue = 0;
    sortValue += header.indexOf('YEAR') != -1 ? 10 : 0;
    sortValue += header.indexOf('Företagare') != -1 ? 2 : 0;
    return -sortValue;
};
/* Creates filterers for filtering the chart data returned by the backend on series name.*/
exports.seriesNamesFilterer = function (seriesNames) {
    return function (chartData) {
        var seriesNamesToInclude = lodash_1.default.concat([exports.DataDescriptionYearName], seriesNames);
        var namePred = function (name) { return lodash_1.default.some(seriesNamesToInclude, function (s) { return name.indexOf(s) !== -1; }); };
        var dataSeriesIndicesToKeep = lodash_1.default(chartData.attributes.datadesc)
            .pickBy(function (dd) { return namePred(dd.name); }) // only pick series matching name
            .keys() // just the indices
            .map(Number) // convert array indices to numbers
            .value();
        var filterIndices = function (__, index) { return lodash_1.default.includes(dataSeriesIndicesToKeep, index); };
        var updatedDataDesc = chartData.attributes.datadesc.filter(filterIndices);
        var updatedData = chartData.data.data.map(function (dataRow) { return dataRow.filter(filterIndices); });
        var updatedHeader = chartData.data.header.filter(filterIndices);
        var updatedTypes = chartData.data.types.filter(filterIndices);
        var indexMap = lodash_1.default.reduce(updatedHeader, function (acc, value, index) {
            var _a;
            return __assign(__assign({}, acc), (_a = {}, _a[index] = seriesHeaderSortValue(value), _a));
        }, {});
        var indexMapSorter = function (array) {
            var withSortValue = array.map(function (value, index) { return ({ value: value, sortValue: indexMap[index] }); });
            return lodash_1.default(withSortValue).sortBy(function (elem) { return elem.sortValue; }).map(function (elem) { return elem.value; }).value();
        };
        updatedDataDesc = indexMapSorter(updatedDataDesc);
        updatedData = updatedData.map(function (row) { return indexMapSorter(row); });
        updatedHeader = indexMapSorter(updatedHeader);
        updatedTypes = indexMapSorter(updatedTypes);
        var updatedDataData = {
            data: updatedData,
            header: updatedHeader,
            types: updatedTypes,
        };
        return {
            attributes: __assign(__assign({}, chartData.attributes), { datadesc: updatedDataDesc }),
            data: updatedDataData
        };
    };
};
